/**
 * Monta filtros RSQL sem concatenar texto à mão. As aspas e os escapes ficam
 * aqui, para que um valor digitado pela pessoa nunca mude a estrutura do
 * filtro.
 *
 * ```ts
 * rsql.and(rsql.eq('active', true), rsql.contains('name', busca))
 * // active==true;name=="*silva*"
 * ```
 */
/** Aspas duplas sempre: o valor nunca é confundido com operador. */
const quote = (value) => typeof value === 'string'
    ? `"${value.replace(/["\\]/g, (char) => `\\${char}`)}"`
    : String(value);
/** `*` é curinga no `==` de texto; o literal vira `\*`. */
const literal = (text) => text.replace(/[\\*]/g, (char) => `\\${char}`);
const comparison = (operator) => (field, value) => `${field}${operator}${quote(value)}`;
const list = (operator) => (field, values) => `${field}${operator}(${values.map(quote).join(',')})`;
/** Agrupa com parênteses só quando há mais de uma parte. */
const join = (separator) => (...parts) => {
    const present = parts.filter((part) => typeof part === 'string' && part !== '');
    if (present.length <= 1) {
        return present[0] ?? '';
    }
    return present
        .map((part) => part.includes(';') || part.includes(',') ? `(${part})` : part)
        .join(separator);
};
export const rsql = {
    eq: comparison('=='),
    ne: comparison('!='),
    gt: comparison('=gt='),
    ge: comparison('=ge='),
    lt: comparison('=lt='),
    le: comparison('=le='),
    in: list('=in='),
    out: list('=out='),
    isNull: (field, isNull = true) => `${field}=null=${isNull}`,
    /** Texto que contém `text`, sem diferença de maiúsculas. */
    contains: (field, text) => `${field}==${quote(`*${literal(text)}*`)}`,
    /** Texto que começa com `text`. */
    startsWith: (field, text) => `${field}==${quote(`${literal(text)}*`)}`,
    /** Partes vazias, `false` ou `null` são ignoradas, para filtros opcionais. */
    and: join(';'),
    or: join(','),
};
//# sourceMappingURL=rsql.js.map